export const errorTypes = {
  required: 'REQUIRED',
  invalid: 'INVALID_FORMAT',
  minDate: 'BELOW_MIN_DATE',
  maxDate: 'ABOVE_MAX_DATE',
  blackoutDate: 'IS_BLACKOUT_DATE',
  dateRangeOrder: 'DATE_RANGE_ORDER',
  minNumber: 'BELOW_MIN_NUMBER',
  maxNumber: 'ABOVE_MAX_NUMBER',
  minItems: 'BELOW_MIN_ITEMS',
  maxItems: 'ABOVE_MAX_ITEMS'
};